import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchAllConfigs } from '../../store/config';

const ConfigProvider = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAllConfigs());
    }, [dispatch]);

    return <></>;
};

export default ConfigProvider;
